export const wrapWith = (Wrapper, wrapperProps) => (Component) => {
  const WrapWith = (props) => (
    <Wrapper
      {...props}
      {...wrapperProps}
    >
      <Component {...props} />
    </Wrapper>
  );

  WrapWith.displayName = `WrapWith(${Wrapper.displayName || Wrapper.name})`;

  return WrapWith;
};
